
import { Component, Vue, Prop } from 'vue-property-decorator';

import selectUser from '../staff/components/setStaff.vue';
// [AMapReplace->OrderArea 20260825] 原地图选点组件 PickAddressInMap 替换为 OrderArea 省市区选择器
import OrderArea from '@/views/order/components/OrderArea.vue';
import { getAllClockUserList, getClockInSet, getClockUserList, setClockInAddress, setClockInInfo, setClockUser, switchClockUser } from '@/api/clockInSetting';
import { UserModule } from '@/store/modules/user';
import { IUserItem } from '@/types/orderCheck';
import { parse } from 'path';
import { Parser } from 'html2canvas/dist/types/css/syntax/parser';

@Component({
  name: 'ClockInSetting',
  components: {
    selectUser,
    OrderArea
  }
})
export default class extends Vue {
  private activeSetting = 'first'
  // private openUser = false

  // private dialogSetStaffVisible = false
  private setClass = {
    // 考勤人员 - 启用考勤人员
    is_user: false,

    // 考勤班次
    is_time: false, // 启用考勤班次
    workday: [], // 工作日设置
    is_holiday_rest: false, // 法定节假日自动排休

    // 打卡时段
    is_clocking_time: false, // 打卡时段设置
    start_time: '00:00',
    end_time: '23:59',
    one_on_duty_time: ['00:00', '23:59'],
    one_off_duty_time: ['00:00', '23:59'],

    // 弹性打卡
    is_elastic_clock: false, // 晚到 早走 不计异常
    elastic_late_time: '',
    latetime_str: '',
    elastic_early_time: '',
    earlytime_str: '',

    // 更多设置
    is_absenteeism: false, // 旷工
    absenteeism_time: 0
  }

  private settingclasses = {

  }

  // 考勤地址model
  private setAddress = {
    is_position: false,
    address: '',
    limit_position: '',
    latitude: '',
    longitude: ''
  }

  private addressRangeOptions = [{
    value: '100',
    label: '100米'
  }, {
    value: '200',
    label: '200米'
  }, {
    value: '300',
    label: '300米'
  }, {
    value: '400',
    label: '400米'
  }, {
    value: '500',
    label: '500米'
  }, {
    value: '600',
    label: '600米'
  }, {
    value: '700',
    label: '700米'
  }, {
    value: '800',
    label: '800米'
  }, {
    value: '900',
    label: '900米'
  }, {
    value: '1000',
    label: '1000米'
  }, {
    value: '2000',
    label: '2000米'
  }, {
    value: '3000',
    label: '3000米'
  }]

  private userPage = 1;
  private userSelectedAll= false; // 全选中
  private isIndeterminate= false; // 全选框 模糊状态

  private dialogTableUsersVisible = false;
  private loadMoreBtnVisible = true;
  private searchForm = {
    name: ''
  };
  private selectedUserInRequest = [{
    'user_id': '',
    'user_name': ''
  }]

  private usersData: IUserItem[] = [];// 所有人员数据源
  private selectedStaff = []; // 已经启用的考勤人员

  private selectedItem: any = [];// 标记所有人员中已经选择的人员
  private selectUser:any = [];// 最后确认选择的人员
  private SelectedDynamicTags: any[] = [];// 选择人员的tag标签

  // 生命周期
  created() {
    // 主要参考 OrderCheckSetting (选择考勤人员)  和  CustomerAddDialog (地图选择) thx
    this.getClockInSet();
    this.getClockUserList();
  }

  // 点击 选择考勤人员按钮
  private handleSelectUsers(val: any) {
    this.dialogTableUsersVisible = true;
    this.getAllClockInUserList();
  }

  // 确认考勤人员选择
  private setClockUserClick() {
    this.userPage = 1;
    this.setClockUserList();
  }

  // 加载更多人员
  private handleLoadMoreUser() {
    this.userPage += 1;
    this.getAllClockInUserList();
  }

  // 搜索考勤人员
  private handleSearchUser() {
    this.usersData = [];
    this.getAllClockInUserList();
  }

  // 清除人员搜索
  private handleClearUserSearch() {
    this.userPage = 1;
    this.usersData = [];
    this.searchForm.name = '';
    this.loadMoreBtnVisible = true;
    this.getAllClockInUserList();
  }

  // 弹窗取消
  private dialogUserCancle() {
    this.dialogTableUsersVisible = false;
    this.userSelectedAll = false;
    this.usersData = [];
    this.selectUser = [];
    this.SelectedDynamicTags = [];
    this.searchForm.name = '';
    this.userPage = 1;
  }

  // 人员全选按钮
  private userSelectionAll() {
    if (this.userSelectedAll) {
      // 全选
      for (let i = 0; i < this.usersData.length; i++) {
        let index = this.selectUser.indexOf(this.usersData[i].id);
        if (index === -1) {
          this.selectUser.push(this.usersData[i].id);
          this.SelectedDynamicTags.push(this.usersData[i]);
        }
      }
      this.userSelectedAll = true;
      this.isIndeterminate = false;
    } else {
      // 全不选
      this.selectUser = [];
      this.SelectedDynamicTags = [];
    }
  }

  // 单个选择考勤人员
  private userSelection(item: any) {
    if (this.selectUser.length > this.SelectedDynamicTags.length) {
      this.SelectedDynamicTags.push(item);
      // 东改
      if (this.selectUser.length === this.usersData.length) {
        this.userSelectedAll = true;
        this.isIndeterminate = false;
      } else {
        this.userSelectedAll = false;
        this.isIndeterminate = true;
      }
    } else {
      for (let i = 0; i < this.SelectedDynamicTags.length; i++) {
        if (this.SelectedDynamicTags[i].id === item.id) {
          this.SelectedDynamicTags.splice(i, 1);
          break;
        }
      }
      // 东改
      if (this.selectUser.length === 0) {
        this.userSelectedAll = false;
        this.isIndeterminate = false;
      } else {
        this.isIndeterminate = true;
      }
    }
  }

  // tags 行 取消某个人员选择
  private handleCloseTag(val: any) {
    if (this.selectUser && this.selectUser.length > 0) {
      for (var i = 0; i < this.selectUser.length; i++) {
        if (this.selectUser[i] === val.id) {
          this.selectUser.splice(i, 1);
        }
      }
    }
    if (this.SelectedDynamicTags && this.SelectedDynamicTags.length > 0) {
      for (var m = 0; m < this.SelectedDynamicTags.length; m++) {
        if (this.SelectedDynamicTags[m].id === val.id) {
          this.SelectedDynamicTags.splice(m, 1);
        }
      }
    }
    // 东改
    if (this.selectUser.length === 0) {
      this.userSelectedAll = false;
      this.isIndeterminate = false;
    } else {
      this.userSelectedAll = false;
      this.isIndeterminate = true;
    }
  }

  // 启用/关闭考勤人员
  private openUserSwich() {
    this.switchClockUser();
  }

  // 保存考勤班次
  private classesSubmit() {
    // 如果 时间范围选择符合逻辑 才可以提交
    if (this.checkClockTimeRange()) {
      this.setClockInInfo();
    }
  }

  // 保存考勤地址
  private addressSubmit() {
    this.setClockInAddress();
  }

  // 获取考勤设置信息
  getClockInSet(val?: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
    };
    getClockInSet(params)
      .then(res => {
        if (res.data) {
          // 学习 此处设置  导致 打卡范围限制 无法正常选择时间  原因待定
          // this.setClass = res.data;

          // 启用考勤人员
          this.setClass.is_user = res.data['is_user'] === '1';

          // 考勤班次设置
          let workday = res.data['workday'];
          this.setClass.workday = workday.split(',');

          this.setClass.is_time = res.data['is_time'] === '1';
          this.setClass.is_holiday_rest = res.data['is_holiday_rest'] === '1';

          // 打卡时段  上下班时间
          this.setClass.is_clocking_time = res.data['is_clocking_time'] === '1';
          this.setClass.start_time = res.data['start_time'];
          this.setClass.end_time = res.data['end_time'];

          // 打卡范围设置
          this.setClass.one_on_duty_time = [res.data['one_on_duty_start_time'], res.data['one_on_duty_end_time']];
          this.setClass.one_off_duty_time = [res.data['one_off_duty_start_time'], res.data['one_off_duty_end_time']];

          // 弹性打卡设置
          this.setClass.is_elastic_clock = res.data['is_elastic_clock'] === '1';
          let lateTime = res.data['elastic_late_time'];
          let earlyTime = res.data['elastic_early_time'];
          this.setClass.elastic_late_time = lateTime === '' ? '00:00' : lateTime;
          this.setClass.elastic_early_time = earlyTime === '' ? '00:00' : earlyTime;

          let lateArr = this.setClass.elastic_late_time.split(':');
          let earlyArr = this.setClass.elastic_early_time.split(':');
          this.setClass.latetime_str = lateArr[0] + '小时' + lateArr[1] + '分钟';
          this.setClass.earlytime_str = earlyArr[0] + '小时' + earlyArr[1] + '分钟';

          // 旷工
          this.setClass.is_absenteeism = res.data['is_absenteeism'] === '1';
          this.setClass.absenteeism_time = res.data['absenteeism_time'];

          // 考勤地址设置
          this.setAddress = res.data;
          this.setAddress.is_position = res.data['is_position'] === '1';
        } else {
          // this.setClass = ;
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }

  // 获取所有考勤工程师列表
  getAllClockInUserList() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_name: this.searchForm.name,
      page: this.userPage
    };
    getAllClockUserList(params)
      .then(res => {
        if (res && res.data) {
          if (res.data.page_count <= this.userPage) {
            this.loadMoreBtnVisible = false;
          } else {
            this.loadMoreBtnVisible = true;
          }
          for (const item of res.data.list) {
            const user: IUserItem = {
              id: item.id,
              name: item.name,
              account: item.account || item.account_mobile,
              phone: item.mobile,
              department: item.department_name || '无部门',
              role: item.role_name
            };
            this.usersData.push(user);
          }
        }
        // 进一步学习 此处遍历方式
        if (this.selectedItem !== null && this.userPage === 1) {
          for (const item of this.selectedItem) {
            let index = this.selectUser.indexOf(item.id);
            if (index === -1) { // 如果此selectUser里没有此数据
              this.selectUser.push(item.id);
              this.SelectedDynamicTags.push(item);
            }
          }
          // 东改
          if (this.selectUser.length === this.usersData.length) {
            this.userSelectedAll = true;
            this.isIndeterminate = false;
          } else {
            this.userSelectedAll = false;
            this.isIndeterminate = true;
          }
        }
      })
      .catch(err => {
        this.loadMoreBtnVisible = false;
        let msg = err.msg;
      });
  }

  // 已选择的考勤人员列表
  getClockUserList(val?: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
    };
    getClockUserList(params)
      .then(res => {
        if (res.data) {
          this.selectedStaff = res.data;

          // 此处增加一个判断
          this.selectedItem = [];
          for (const item of res.data) {
            const user: IUserItem = {
              id: item.user_id,
              name: item.user_name
            };
            this.selectedItem.push(user);
          }
        } else {
          this.selectedStaff = [];
        }
      })
      .catch(err => {
        let msg = err.msg;
        this.selectedStaff = [];
      });
  }

  // 设置考勤人员
  setClockUserList(val?: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      selected_user: this.selectUser.join(',')
    };
    setClockUser(params)
      .then(res => {
        if (res) {
          this.showSuccessMsg('设置成功');
          this.getClockUserList();
          this.dialogUserCancle();
        } else {
          // this.tableData = [];
        }
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  // 启用、关闭考勤人员
  switchClockUser() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      is_user: this.setClass.is_user ? 1 : 0
    };
    switchClockUser(params)
      .then(res => {
        if (res.data) {
          let msg = this.setClass.is_user ? '启用成功' : '关闭成功';
          this.showSuccessMsg(msg);
        } else {
          this.showErrorMsg('服务异常');
        }
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  // 设置考勤班次
  setClockInInfo() {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      is_time: this.setClass.is_time ? 1 : 0,
      workday: this.setClass.workday.join(','),
      is_holiday_rest: this.setClass.is_holiday_rest ? 1 : 0,
      commuting_times: 1,
      is_clocking_time: this.setClass.is_clocking_time ? 1 : 0,
      start_time: this.setClass.start_time,
      end_time: this.setClass.end_time,
      is_elastic_clock: this.setClass.is_elastic_clock ? 1 : 0,
      elastic_late_time: this.setClass.elastic_late_time,
      elastic_early_time: this.setClass.elastic_early_time,
      is_absenteeism: this.setClass.is_absenteeism ? 1 : 0,
      absenteeism_time: this.setClass.absenteeism_time
    };
    if (this.setClass.is_clocking_time) {
      params.one_on_duty_start_time = this.setClass.one_on_duty_time[0];
      params.one_on_duty_end_time = this.setClass.one_on_duty_time[1];
      params.one_off_duty_start_time = this.setClass.one_off_duty_time[0];
      params.one_off_duty_end_time = this.setClass.one_off_duty_time[1];
    }
    setClockInInfo(params)
      .then(res => {
        if (res.data) {
          this.showSuccessMsg('操作成功');
        } else {
          this.showErrorMsg('服务异常');
        }
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  private showAddressDialog=false;

  // 打开地图dialog
  private openMap() {
    this.showAddressDialog = true;
  }

  // 关闭地图dialog
  private closeAddress(close: boolean) {
    this.showAddressDialog = close;
  }

  // [AMapReplace->OrderArea 20260825] 原地图选点回调 positionPicker 改为省市区选择回调 areaSave；
  // OrderArea 仅提供省市区，latitude/longitude 不再由组件回填，考勤地址以所选省市区回填后可在输入框中继续编辑补充
  private saveAreaHandle(area: any) {
    if (area) {
      this.setAddress.address = area.province_name + '  ' + area.city_name + '  ' + area.district_name;
    }
  }

  // 设置考勤地址
  setClockInAddress() {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      is_position: this.setAddress.is_position ? 1 : 0,
      address: this.setAddress.address,
      limit_position: this.setAddress.limit_position,
      latitude: this.setAddress.latitude,
      longitude: this.setAddress.longitude
    };
    setClockInAddress(params)
      .then(res => {
        if (res.data) {
          this.showSuccessMsg('操作成功');
        } else {
          this.showErrorMsg('服务异常');
        }
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  // 时间范围选择是否符合逻辑
  private checkClockTimeRange() {
    if (!this.setClass.is_clocking_time) {
      return true;
    }
    let startTime = this.setClass.start_time.replace(':', '');
    let endTime = this.setClass.end_time.replace(':', '');
    let startRange1 = this.setClass.one_on_duty_time[0].replace(':', '');
    let startRange2 = this.setClass.one_on_duty_time[1].replace(':', '');
    let endRange1 = this.setClass.one_off_duty_time[0].replace(':', '');
    let endRange2 = this.setClass.one_off_duty_time[1].replace(':', '');

    if (parseInt(startTime) < parseInt(startRange1) || parseInt(startTime) > parseInt(startRange2)) {
      this.showErrorMsg('上班时间应该在上班打卡时间范围内');
      return false;
    }
    if (parseInt(endTime) < parseInt(endRange1) || parseInt(endTime) > parseInt(endRange2)) {
      this.showErrorMsg('下班时间应该在下班打卡时间范围内');
      return false;
    }
    if (parseInt(startRange2) > parseInt(endRange1)) {
      this.showErrorMsg('上班打卡最晚时间不能超过下班打卡开始时间');
      return false;
    }
    return true;
  }

  // hud 提示
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }

  private lateTimeChange() {

  }

  private earlyTimeChange() {

  }
  // 选择考勤人员
  // private closeStaff(val: boolean) {
  //   this.dialogSetStaffVisible = val;
  // }
}
